// doorDepts.js — OLM1 dock door -> department, for the TDR Rel→Create by Dept card.
// Sources (existing JarJar OLM1 maps): DeptWash/Fallin PROD_DOORS (PID, PR, SKID,
// MANR), fmc-fill-sync.sh OB fill classes (Sorter/Fluid Direct 103-116, Offline
// Fluid 117-134, Palletized 302-344), yms-backfill-all.sh (PR 130-159).
// AROS = the MANR doors (DD347-348) — CONFIRM with site.
export const TDR_DEPTS = ['PID', 'AROS', 'PR', 'Sorter Fluid', 'Offline Fluid', 'OBPR', 'Other'];

const RANGES = {
  OLM1: [
    ['PID', 352, 360],
    ['AROS', 347, 348],
    ['PR', 135, 159],
    ['Sorter Fluid', 103, 116],
    ['Offline Fluid', 117, 134],
    ['OBPR', 302, 344],
  ],
};

export function doorDept(location, site = 'OLM1') {
  const m = /^DD0*(\d+)$/i.exec(String(location || '').trim());
  if (!m) return 'Other';
  const n = Number(m[1]);
  const hit = (RANGES[site] || []).find(([, lo, hi]) => n >= lo && n <= hi);
  return hit ? hit[0] : 'Other';
}
